[
  {
    "code": "KZ-ALA",
    "name": "Almaty"
  },
  {
    "code": "KZ-ALM",
    "name": "Almaty oblysy"
  },
  {
    "code": "KZ-AKM",
    "name": "Aqmola oblysy"
  },
  {
    "code": "KZ-AKT",
    "name": "Aqtöbe oblysy"
  },
  {
    "code": "KZ-AST",
    "name": "Astana"
  },
  {
    "code": "KZ-ATY",
    "name": "Atyrau oblysy"
  },
  {
    "code": "KZ-ZAP",
    "name": "Batys Qazaqstan oblysy"
  },
  {
    "code": "KZ-MAN",
    "name": "Mangghystau oblysy"
  },
  {
    "code": "KZ-YUZ",
    "name": "Ongtüstik Qazaqstan oblysy"
  },
  {
    "code": "KZ-PAV",
    "name": "Pavlodar oblysy"
  },
  {
    "code": "KZ-KAR",
    "name": "Qaraghandy oblysy"
  },
  {
    "code": "KZ-KUS",
    "name": "Qostanay oblysy"
  },
  {
    "code": "KZ-KZY",
    "name": "Qyzylorda oblysy"
  },
  {
    "code": "KZ-VOS",
    "name": "Shyghys Qazaqstan oblysy"
  },
  {
    "code": "KZ-SEV",
    "name": "Soltüstik Qazaqstan oblysy"
  },
  {
    "code": "KZ-ZHA",
    "name": "Zhambyl oblysy"
  }
]